
export default function AboutSection() {
  const pillars = [
    {
      icon: 'ri-building-line',
      title: 'UAE-Strukturen',
      features: [
        'Freezones & Firmengründung',
        'Residency & Banking',
        'Steueroptimierung',
        'Rechtssichere Setups'
      ]
    },
    {
      icon: 'ri-home-office-line',
      title: 'Immobilien-Zugang',
      features: [
        'Geprüfte Projekte',
        'Co-Investment-Modelle',
        'Developer-Netzwerk',
        'Off-Market-Deals'
      ]
    },
    {
      icon: 'ri-team-line',
      title: 'Experten-Kreis',
      features: [
        'Steuerberater (DE/AT/UAE)',
        'Rechtsanwälte',
        'Strukturberater',
        'Unternehmer-Community'
      ]
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-neutral-900 relative overflow-hidden">
      {/* Subtle Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-yellow-600/10 text-yellow-600 px-4 sm:px-6 py-2 rounded-full mb-4 sm:mb-6">
            <i className="ri-vip-crown-line text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
            <span className="font-light tracking-wide text-sm sm:text-base">Exklusiver und limitierter Zugang</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl mb-4 sm:mb-6 text-gray-900 px-4">
            Bewerbungsbasierte Mitgliedschaft
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto font-light leading-relaxed px-4">
            Der Dubai Business Club ist keine offene Veranstaltung. Wir prüfen jede Bewerbung individuell und entscheiden über die Aufnahme basierend auf Substanz, Seriosität und gegenseitigem Mehrwert.
          </p>
        </div>

        {/* Three Pillars */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-7xl mx-auto">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-neutral-950 border-t border-yellow-600/50 p-6 sm:p-8 lg:p-10 hover:-translate-y-2 transition-all duration-500 group cursor-pointer"
            >
              {/* Icon */}
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${pillar.icon} text-3xl sm:text-4xl text-yellow-600 group-hover:scale-110 transition-transform duration-300`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-light text-white mb-4 sm:mb-6 tracking-wide">
                {pillar.title}
              </h3>

              {/* Features */}
              <ul className="space-y-2 sm:space-y-3">
                {pillar.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-2 sm:gap-3 text-white/70 font-light text-sm sm:text-base">
                    <i className="ri-check-line text-yellow-600 text-base sm:text-lg mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Link */}
              <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-white/10">
                <span className="text-white/50 text-xs sm:text-sm font-light hover:text-yellow-600 transition-colors inline-flex items-center gap-2 cursor-pointer group/link">
                  Mehr erfahren
                  <i className="ri-arrow-right-line group-hover/link:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 sm:mt-16">
          <a
            href="#bewerbung"
            className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-yellow-600 text-black rounded-full hover:bg-yellow-500 transition-colors group whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            <span className="font-light tracking-wide">Jetzt bewerben</span>
            <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
